import React from 'react';

/**
 * 26×26 icon button used in table action columns.
 * Props:
 *   - icon: string or ReactNode (emoji or SVG)
 *   - onClick: handler
 *   - title: tooltip
 *   - color: 'accent' (default) | 'danger' | 'muted'
 *   - disabled: bool
 */
const COLORS = {
  accent: 'text-accent hover:bg-surface-border',
  danger: 'text-steam-danger hover:bg-surface-border',
  muted:  'text-surface-muted hover:bg-surface-border'
};

export default function IconButton({ icon, onClick, title, color = 'accent', disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      disabled={disabled}
      className={`w-[26px] h-[26px] flex items-center justify-center bg-surface-border/60 text-xs rounded-[2px] transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${COLORS[color] || COLORS.accent}`}
    >
      {icon}
    </button>
  );
}
